import { render, staticRenderFns } from "./Cadastro-Usuarios-Adicionar-Admin.vue?vue&type=template&id=6b259080&scoped=true&"
import script from "./Cadastro-Usuarios-Adicionar-Admin.vue?vue&type=script&lang=js&"
export * from "./Cadastro-Usuarios-Adicionar-Admin.vue?vue&type=script&lang=js&"
import style0 from "./Cadastro-Usuarios-Adicionar-Admin.vue?vue&type=style&index=0&id=6b259080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b259080",
  null
  
)

component.options.__file = "Cadastro-Usuarios-Adicionar-Admin.vue"
export default component.exports